import React, { useEffect, useState } from 'react';
import { get, getDatabase, ref, set, update } from 'firebase/database';
import { Alert, Button, ButtonGroup, Container, Form, Table } from 'react-bootstrap';
import { firebaseApp } from '../../..';

interface Products_Commission {
  [sku: string]: {
    type: string;
    amount: string;
  };
}

const ProductCommissions = () => {
  const [busy, setBusy] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [newSku, setNewSku] = useState('');
  const [newAmount, setNewAmount] = useState('');
  const [newType, setNewType] = useState('');
  const [productCommission, setProductCommission] = useState<Products_Commission>();
  const [newProduct, setNewProduct] = useState<Products_Commission>();
  const db = getDatabase(firebaseApp);

  const searchSku = () => {
    const prodComRef = ref(db, `products_commission/${searchText}`);
    get(prodComRef).then((prodCom) => {
      if (prodCom.val()) {
        console.log('prodCom', prodCom.val());
        setProductCommission(prodCom.val());
      } else {
        alert('Sku is not in the database');
      }
    });
  };

  const saveNewProductCommission = async () => {
    const newSkuValue = {
      amount: newAmount,
      type: newType,
    };

    const updatedProduct = {
      ...newProduct,
      [newSku]: {
        type: newType,
        amount: newAmount,
      },
    };

    setNewProduct(updatedProduct);

    if (newSku && newAmount && newType) {
      const newref = ref(db, `products_commission`);
      try {
        await update(newref, updatedProduct);
        console.log('Data saved successfully');
      } catch (error) {
        console.error('Error saving data:', error);
      }
    }
  };

  console.log('newProduct', newProduct);
  return (
    <div>
      <input
        type="text"
        name="search"
        id="search"
        placeholder="search sku"
        onChange={(event) => setSearchText(event.target.value)}
      />
      <button
        onClick={searchSku}
        style={{
          color: 'var(--secondaryColor)',
          backgroundColor: 'var(--primaryColor)',
          border: '1px solid var(--primaryColor)',
        }}
      >
        search
      </button>
      <br />
      <br />
      {productCommission ? (
        <div>
          <Table hover responsive bordered>
            <thead style={{ borderWidth: 'thin' }}>
              <th style={{ color: 'black' }}>SKU</th>
              <th style={{ color: 'black' }}>Amount</th>
              <th style={{ color: 'black' }}>Type</th>
            </thead>
            <tbody>
              <tr>
                <td>{searchText}</td>
                <td>{productCommission.amount}</td>
                <td>{productCommission.type}</td>
              </tr>
            </tbody>
          </Table>
        </div>
      ) : null}

      <form
        onSubmit={(event) => {
          event.preventDefault(); // Prevents the default form submission behavior
          saveNewProductCommission();
        }}
      >
        <input
          type="text"
          name="sku"
          id="sku"
          placeholder="sku"
          onChange={(event) => setNewSku(event.target.value)}
        />
        <input
          type="text"
          name="amount"
          id="amount"
          placeholder="amount"
          onChange={(event) => setNewAmount(event.target.value)}
        />
        <input
          type="text"
          name="type"
          id="type"
          placeholder="type"
          onChange={(event) => setNewType(event.target.value)}
        />

        <button
          type="submit" // Make sure to specify the type as "submit" for the button
          style={{
            color: 'var(--secondaryColor)',
            backgroundColor: 'var(--primaryColor)',
            border: '1px solid var(--primaryColor)',
          }}
        >
          Save
        </button>
      </form>
      <br />
      <br />
      <br />
    </div>
  );
};

export default ProductCommissions;
